import { VisitCreatingFormData } from '@lmt/unicorn-shared/app/components/calendar/visit/common/types';
import i18next from 'i18next';
import * as yup from 'yup';

const requiredMessage = () => i18next.t('translation:errors.required');
export const visitYupSchema: yup.SchemaOf<VisitCreatingFormData> = yup.object({
  patient: yup.mixed().required(requiredMessage) as any,
  caseId: yup.number().nullable().required(requiredMessage),
  resources: yup.mixed() as any,
  visitTypeId: yup.number().nullable().required(requiredMessage),
  note: yup.string().nullable().trim().max(1000).defined(),
  alertPatient: yup.number().nullable().defined(),
  waitingList: yup.boolean().required(requiredMessage),
  priority: yup.mixed().nullable(),
  dateTimeInterval: yup.object().shape({
    startDate: yup.mixed().nullable().required(requiredMessage),
    startTimeInMills: yup.number().nullable().required(requiredMessage),
    endDate: yup.mixed().nullable().required(requiredMessage),
    endTimeInMills: yup.number().nullable().required(requiredMessage),
  }),
  priorityContactType: yup.mixed().nullable().defined(),
  takenTimeSlots: yup.array().of(yup.mixed<Interval>() as any),
  attendingDoctorId: yup.number().nullable(),
  statusId: yup.mixed().nullable(),
});
